var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackWhiteYellowSimpleInitialNameLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0e1559a212"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 167 92.679688 L 274.976562 92.679688 L 274.976562 248.679688 L 167 248.679688 Z M 167 92.679688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b01940475e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74 143 L 211 143 L 211 248.679688 L 74 248.679688 Z M 74 143 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0e1559a212)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fbb03b",
    d: "M 274.941406 203.335938 C 274.941406 215.441406 270.230469 226.824219 261.683594 235.386719 C 253.136719 243.945312 241.769531 248.683594 229.683594 248.683594 L 204.34375 248.683594 L 215.195312 226.449219 L 229.675781 226.449219 C 242.390625 226.449219 252.734375 216.089844 252.734375 203.359375 C 252.734375 190.632812 242.390625 180.273438 229.675781 180.273438 L 211.0625 180.273438 C 199.386719 180.273438 188.402344 175.699219 180.144531 167.429688 C 171.886719 159.160156 167.335938 148.148438 167.335938 136.449219 C 167.335938 124.75 171.886719 113.761719 180.144531 105.492188 C 188.402344 97.21875 199.386719 92.679688 211.0625 92.679688 L 259.625 92.679688 L 233.921875 145.332031 C 232.519531 145.226562 211.0625 145.167969 211.0625 145.167969 C 210.480469 145.167969 209.914062 145.113281 209.359375 145.003906 L 224.054688 114.910156 L 211.0625 114.910156 C 199.199219 114.910156 189.542969 124.585938 189.542969 136.46875 C 189.542969 148.351562 199.195312 158.027344 211.0625 158.027344 L 229.675781 158.027344 C 241.765625 158.027344 253.132812 162.722656 261.679688 171.28125 C 270.230469 179.847656 274.941406 191.230469 274.941406 203.335938 Z M 274.941406 203.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b01940475e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00aeef",
    d: "M 210.625 193.066406 L 183.492188 248.679688 L 176.839844 248.679688 L 137.789062 168.671875 L 98.742188 248.679688 L 74.027344 248.679688 L 125.496094 143.296875 L 125.496094 143.359375 L 150.148438 143.359375 L 180.164062 204.84375 L 188.238281 188.265625 C 195.207031 191.34375 202.789062 193.007812 210.625 193.066406 Z M 210.625 193.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackWhiteYellowSimpleInitialNameLogo2);
export default __webpack_public_path__ + "static/media/Black White Yellow Simple Initial Name Logo (2).4cb09a10db26045b0e5053661447a63f.svg";
export { ForwardRef as ReactComponent };